
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M18 7.00001H16C15.45 7.00001 15 7.45001 15 8.00001V10C15 10.55 15.45 11 16 11V13H13V5.00001H14C14.41 5.00001 14.65 4.53001 14.4 4.20001L12.4 1.53001C12.2 1.26001 11.8 1.26001 11.6 1.53001L9.59999 4.20001C9.34999 4.53001 9.58999 5.00001 9.99999 5.00001H11V13H7.99999V10.93C8.82999 10.49 9.37999 9.57001 9.13999 8.50001C8.96999 7.73001 8.36999 7.10001 7.61999 6.89001C6.14999 6.48001 4.79999 7.59001 4.79999 9.00001C4.79999 9.85001 5.29999 10.56 5.99999 10.93V13C5.99999 14.1 6.89999 15 7.99999 15H11V18.05C10.14 18.5 9.60999 19.47 9.86999 20.54C10.05 21.29 10.66 21.92 11.41 22.12C12.87 22.51 14.21 21.42 14.21 20C14.21 19.15 13.72 18.42 13.01 18.05V15H16.01C17.11 15 18.01 14.1 18.01 13V11C18.56 11 19.01 10.55 19.01 10V8.00001C19 7.45001 18.55 7.00001 18 7.00001Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-usb`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconUsb

    ```js
    <b-new-b-icon-usb />
    ```
</docs>


